(function () {
  // Desktop only
  if (window.innerWidth < 1100) return;

  const header = document.querySelector('.header-wrapper');
  const AA2 = document.querySelector('[id*="announcement_bar_bMXTKN"]');
  const menuItems = document.querySelectorAll('.header__menu-item--mega');

  if (!header || !AA2) return;

  // ---- POSITION HANDLER (FIXES MAC ISSUE) ----
  function setAA2Position() {
    requestAnimationFrame(() => {
      const headerHeight = header.getBoundingClientRect().height;
      AA2.style.top = headerHeight + 'px';
    });
  }

  // ---- RUN AT CORRECT TIMES ----
  window.addEventListener('load', setAA2Position);

  // Fonts (important for Mac Safari/Chrome)
  if (document.fonts) {
    document.fonts.ready.then(setAA2Position);
  }

  // Fallback for Safari weirdness
  setTimeout(setAA2Position, 120);

  // Recalculate when header size changes
  const resizeObserver = new ResizeObserver(setAA2Position);
  resizeObserver.observe(header);

  window.addEventListener('resize', setAA2Position);

  // ---- MENU VISIBILITY HANDLER ----
  const observer = new MutationObserver(() => {
    const isAnyOpen = [...menuItems].some(el =>
      el.classList.contains('menu-open')
    );

    AA2.style.transition = 'opacity 0.2s ease';

    if (isAnyOpen) {
      AA2.style.opacity = '1';
      AA2.style.visibility = 'visible';
    } else {
      AA2.style.opacity = '1';
      AA2.style.visibility = 'visible';
    }
  });

  menuItems.forEach(item => {
    observer.observe(item, {
      attributes: true,
      attributeFilter: ['class']
    });
  });

})();